const API_GATEWAY =
  typeof window !== "undefined"
    ? window?.__RUNTIME_CONFIG__?.API_GATEWAY_URL ??
      "https://api-index.dswalk.com"
    : "/";

export default API_GATEWAY;
